/* global gtag */

import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import MainLayout from "@/views/layouts/main/MainLayout.vue";
import AdminLayout from "@/views/layouts/admin/AdminLayout.vue";
import BioPage from "@/views/pages/bio/BioPage.vue";
import HomePage from "@/views/pages/main/HomePage.vue";

import PriceListPage from "@/views/pages/main/PriceListPage.vue";
import ArtikelPage from "@/views/pages/main/ArtikelPage.vue";
import ArtikelDetailPage from "@/views/pages/main/ArtikelDetailPage.vue";
import GaleryPage from "@/views/pages/main/GaleryPage.vue";
import AboutUs from "@/views/pages/main/AboutUsPage.vue";

import LoginPage from "@/views/pages/admin/LoginPage.vue";

// ADMIN
import DashboardAdmin from "@/views/pages/admin/DashboardAdmin.vue";
import HomeAdmin from "@/views/pages/admin/home-admin/HomeAdmin.vue";

// PRICE LIST ADMIN
import PriceListAdmin from "@/views/pages/admin/price-list-admin/PriceListAdmin.vue";
import ReadPriceList from "@/views/pages/admin/price-list-admin/ReadPriceList.vue";
import EditPriceList from "@/views/pages/admin/price-list-admin/EditPriceList.vue";
import CreatePriceList from "@/views/pages/admin/price-list-admin/CreatePriceList.vue";
// import ReadPaketTour from "@/views/pages/admin/paket-tour-admin/ReadPaketTour.vue";
// import EditPaketTour from "@/views/pages/admin/paket-tour-admin/EditPaketTour.vue";
// import CreatePaketTour from "@/views/pages/admin/paket-tour-admin/CreatePaketTour.vue";

// GALERY ADMIN
import GaleryAdmin from "@/views/pages/admin/galery-admin/GaleryAdmin.vue";
import ReadGalery from "@/views/pages/admin/galery-admin/ReadGalery.vue";
import EditGalery from "@/views/pages/admin/galery-admin/EditGalery.vue";
import CreateGalery from "@/views/pages/admin/galery-admin/CreateGalery.vue";

// ARTIKEL ADMIN
import ArtikelAdmin from "@/views/pages/admin/artikel-admin/ArtikelAdmin.vue";
import ReadArtikel from "@/views/pages/admin/artikel-admin/ReadArtikel.vue";
import EditArtikel from "@/views/pages/admin/artikel-admin/EditArtikel.vue";
import CreateArtikel from "@/views/pages/admin/artikel-admin/CreateArtikel.vue";

import ContactAdmin from "@/views/pages/admin/contact-admin/ContactAdmin.vue";
// import BioPageVue from "@/views/pages/BioPage.vue";

const routes = [
  { 
    path: "/bio", 
    component: BioPage, 
    meta: { 
      title: "Tentang Kami - Bio | GAHARU Outbound Indonesia",
      description: "Pelajari lebih lanjut tentang tim dan nilai-nilai GAHARU Outbound, penyedia outbound dan petualangan terbaik di Indonesia",
      image: "/images/bio-og.jpg"
    } 
  },
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: HomePage,
        meta: { 
          title: "GAHARU Outbound | Paket Outbound Terbaik & Petualangan Alam Indonesia",
          description: "GAHARU Outbound menyediakan paket outbound, team building, dan petualangan alam terbaik di Indonesia. Nikmati aktivitas seru, aman, dan berkesan dengan instruktur berpengalaman.",
          image: "/images/home-og.jpg",
          keywords: "outbound terbaik Indonesia, paket outbound, team building, aktivitas outdoor, petualangan alam, liburan keluarga"
        },
      },
      {
        path: "price-list",
        name: "PriceList",
        component: PriceListPage,
        meta: { 
          title: "Harga Paket Outbound Terjangkau | GAHARU Outbound",
          description: "Lihat harga paket outbound murah dan terjangkau dari GAHARU Outbound. Berbagai pilihan aktivitas outdoor dengan kualitas terbaik di Indonesia.",
          image: "/images/price-list-og.jpg",
          keywords: "paket outbound murah, harga outbound, paket liburan murah, aktivitas outdoor terjangkau"
        },
      },
      {
        path: "artikel",
        name: "Artikel",
        component: ArtikelPage,
        meta: { 
          title: "Blog & Artikel | Tips Outbound dan Petualangan | GAHARU",
          description: "Baca artikel dan tips menarik tentang outbound, petualangan alam, travel, dan aktivitas outdoor di Indonesia dari GAHARU Outbound.",
          image: "/images/artikel-og.jpg",
          keywords: "blog outbound, tips petualangan, panduan aktivitas outdoor, cerita wisata alam Indonesia"
        },
      },
      {
        path: "artikel/:slug",
        name: "ArtikelDetail",
        component: ArtikelDetailPage,
        meta: { 
          title: "Artikel - Blog Petualangan | GAHARU Outbound",
          description: "Baca artikel menarik tentang tips outbound, petualangan, dan aktivitas alam dari GAHARU Outbound Indonesia",
          image: "/images/artikel-default-og.jpg"
        },
      },
      {
        path: "galery",
        name: "Galery",
        component: GaleryPage,
        meta: { 
          title: "Galeri Foto Outbound | Momen Seru Petualangan | GAHARU",
          description: "Lihat galeri foto kegiatan outbound, petualangan alam, dan acara seru dari GAHARU Outbound Indonesia",
          image: "/images/gallery-og.jpg",
          keywords: "galeri foto outbound, foto petualangan, momen kegiatan outdor, foto tim building"
        },
      },
      {
        path: "about-us",
        name: "AboutUs",
        component: AboutUs,
        meta: { 
          title: "Tentang GAHARU Outbound | Penyedia Outbound Terpercaya Indonesia",
          description: "GAHARU Outbound adalah penyedia layanan outbound, team building, dan petualangan outdoor terpercaya dengan instruktur bersertifikat di Indonesia",
          image: "/images/about-og.jpg",
          keywords: "tentang outbound, perusahaan outbound terpercaya, layanan petualangan alam, instruktur outbound profesional"
        },
      },
    ],
  },
  {
    path: "/admin",
    component: AdminLayout,
    children: [
      {
        path: "dashboard",
        name: "DashboardAdmin",
        component: DashboardAdmin,
      },
      {
        path: "home",
        name: "HomeAdmin",
        component: HomeAdmin,
      },

      // Price-List Admin
      {
        path: "price-list",
        name: "PriceListAdmin",
        component: PriceListAdmin,
      },
      {
        path: "price-list/read/:slug",
        name: "ReadPriceList",
        component: ReadPriceList,
      },
      {
        path: "price-list/edit/:slug",
        name: "EditPriceList",
        component: EditPriceList,
      },
      {
        path: "price-list/create",
        name: "CreatePriceList",
        component: CreatePriceList,
      },
      // {
      //   path: "paket-tour/create",
      //   name: "CreatePaketTour",
      //   component: CreatePaketTour,
      //   meta: { title: "CREATE PAKET TOUR", requiresAuth: true },
      // },
      // {
      //   path: "paket-tour/read/:slug",
      //   name: "ReadPaketTour",
      //   component: ReadPaketTour,
      //   meta: { title: "READ PAKET TOUR", requiresAuth: true },
      // },
      // {
      //   path: "paket-tour/edit/:slug",
      //   name: "EditPaketTour",
      //   component: EditPaketTour,
      //   meta: { title: "EDIT PAKET TOUR", requiresAuth: true },
      // },
      {
        path: "paket-tour/delete/:slug",
        name: "DeletePaketTour",
        meta: { title: "EDIT PAKET TOUR", requiresAuth: true },
      },

      // Galery Admin
      {
        path: "galery",
        name: "GaleryAdmin",
        component: GaleryAdmin,
        meta: { title: "GALERY MANAGEMENT", requiresAuth: true },
      },
      {
        path: "galery/create",
        name: "CreateGalery",
        component: CreateGalery,
        meta: { title: "CREATE GALERY", requiresAuth: true },
      },
      {
        path: "galery/read/:id",
        name: "ReadGalery",
        component: ReadGalery,
        meta: { title: "READ GALERY", requiresAuth: true },
      },
      {
        path: "galery/edit/:id",
        name: "EditGalery",
        component: EditGalery,
        meta: { title: "EDIT GALERY", requiresAuth: true },
      },

      // Artikel Admin
      {
        path: "artikel",
        name: "ArtikelAdmin",
        component: ArtikelAdmin,
        meta: { title: "ARTIKEL MANAGEMENT" },
      },
      {
        path: "artikel/create",
        name: "CreateArtikel",
        component: CreateArtikel,
        meta: { title: "CREATE ARTIKEL", requiresAuth: true },
      },
      {
        path: "artikel/read/:slug",
        name: "ReadArtikel",
        component: ReadArtikel,
        meta: { title: "READ ARTIKEL", requiresAuth: true },
      },
      {
        path: "artikel/edit/:slug",
        name: "EditArtikel",
        component: EditArtikel,
        meta: { title: "EDIT ARTIKEL", requiresAuth: true },
      },
      {
        path: "artikel/delete/:slug",
        name: "DeleteArtikel",
        meta: { title: "EDIT ARTIKEL", requiresAuth: true },
      },

      // Contact Admin
      {
        path: "contact",
        name: "ContactAdmin",
        component: ContactAdmin,
        meta: { title: "CONTACT MANAGEMENT", requiresAuth: true },
      },
    ],
  },
  { path: "/admin-login", name: "LoginPage", component: LoginPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // Set meta tags for SEO
  if (to.meta) {
    document.title = to.meta.title || "GAHARU Outbound";
    
    // Update description meta tag
    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta');
      descriptionTag.setAttribute('name', 'description');
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.setAttribute('content', to.meta.description || 'Adventure and outdoor activities with GAHARU Outbound');

    // Update keywords meta tag
    if (to.meta.keywords) {
      let keywordsTag = document.querySelector('meta[name="keywords"]');
      if (!keywordsTag) {
        keywordsTag = document.createElement('meta');
        keywordsTag.setAttribute('name', 'keywords');
        document.head.appendChild(keywordsTag);
      }
      keywordsTag.setAttribute('content', to.meta.keywords);
    }

    // Update og:title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', to.meta.title || 'GAHARU Outbound');

    // Update og:description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', to.meta.description || 'Adventure and outdoor activities');

    // Update og:image
    if (to.meta.image) {
      let ogImage = document.querySelector('meta[property="og:image"]');
      if (!ogImage) {
        ogImage = document.createElement('meta');
        ogImage.setAttribute('property', 'og:image');
        document.head.appendChild(ogImage);
      }
      ogImage.setAttribute('content', window.location.origin + to.meta.image);
    }

    // Update og:url
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', window.location.href);
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({ name: "LoginPage" });
    } else {
      store.dispatch("updateTitle", to.meta.title || "Admin");
      next();
    }
  } else {
    store.dispatch("updateTitle", to.meta.title || "GAHARU Outbound");
    next();
  }
});

// Tracking Navigasi di Vue Router
router.afterEach((to) => {
  if (typeof gtag === "function") {
    gtag("event", "page_view", {
      page_path: to.fullPath,
    });
  }
});

router.afterEach(() => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView");
  }
});

export default router;
